<div *ngIf="isPageLoading" style="display: flex; justify-content: center; align-items: center; height: 60vh;">
  <mat-spinner></mat-spinner>
</div>
<mat-card *ngIf="!isPageLoading"
    class="trinta-card basic-form mb-25 bg-white border-none d-block"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                My Profile
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="profileForm" (submit)="onSubmit()">
            <label for="user" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                Username
            </label>
            <mat-form-field>
                <i-feather name="user"></i-feather>
                <mat-label style="font-size: 16px;">Enter username</mat-label>
                <input style="font-size: 16px;" matInput formControlName="username">
            </mat-form-field>
            <label for="email" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                Email Address
            </label>
            <mat-form-field>
                <i-feather name="mail"></i-feather>
                <mat-label style="font-size: 16px;">Enter email address</mat-label>
                <input style="font-size: 16px;" matInput formControlName="email">
            </mat-form-field>
            <label for="password" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                New Password
            </label>
            <mat-form-field>
                <i-feather name="lock"></i-feather>
                <mat-label style="font-size: 16px;">Enter new password</mat-label>
                <input style="font-size: 16px;" matInput [type]="hide ? 'password' : 'text'" formControlName="password">
                <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <span class="material-symbols-outlined">
                        {{hide ? 'visibility_off' : 'visibility'}}
                    </span>
                </button>
                <mat-error *ngIf="profileForm.get('password')?.hasError('minlength')">
                    Password must be at least 8 characters.
                </mat-error>
            </mat-form-field>
            <label for="confirmPassword" class="label d-block fw-medium mb-10" style="font-size: 16px;">
                Confirm New Password
            </label>
            <mat-form-field>
                <i-feather name="lock"></i-feather>
                <mat-label style="font-size: 16px;">Repeat new password</mat-label>
                <input style="font-size: 16px;" matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword">
                <button type="button" mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirm">
                    <span class="material-symbols-outlined">
                        {{hideConfirm ? 'visibility_off' : 'visibility'}}
                    </span>
                </button>
                <mat-error *ngIf="profileForm.get('confirmPassword')?.dirty && profileForm.hasError('passwordMismatch')">
                    Passwords do not match.
                </mat-error>
            </mat-form-field>
            <button [disabled]="profileForm.invalid || isLoading || profileForm.hasError('passwordMismatch')" mat-button type="submit" style="max-width: 200px;">
                Update password
            </button>
            <br>
            <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
              <mat-progress-bar mode="indeterminate" style="width: 50%;">
              </mat-progress-bar>
            </div>
            <br>
            <div *ngIf="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
            </div>
        </form>
    </mat-card-content>
</mat-card>

<mat-card *ngIf="!isPageLoading"
    class="trinta-card basic-form mb-25 bg-white border-none d-block"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                Delete account
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content style="justify-content: center; display: flex; align-items: center;">
      <button (click)="deleteDialog()" mat-flat-button color="warn" type="button" style="max-width: 300px;">
        Delete my account
    </button>
    </mat-card-content>
</mat-card>
